import { useWorkspaceStore } from "@/hooks/useWorkspace";
import { getCookie } from "@/lib/cookies";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUserData from "@/hooks/useUserData";

const NoWorkspaceFound = () => {
  const navigate = useNavigate();
  const token = getCookie("token");
  const { currentWorkspace, setCurrentWorkspace } = useWorkspaceStore();
  const { user } = useUserData();

  useEffect(() => {
    if (token) {
      // Check if user is a member of the current workspace
      const isUserInCurrentWorkspace = currentWorkspace?.users
        ?.map((u: any) => u._id)
        .includes(user?._id);

      if (currentWorkspace && isUserInCurrentWorkspace) {
        // User is a member, navigate to their workspace
        navigate(`/dashboard/${currentWorkspace._id}`);
      } else if (user?.workspaces?.length > 0) {
        // User is not a member of currentWorkspace (was viewing someone else's)
        // Navigate to their first own workspace instead
        const ownWorkspace = user.workspaces[0];
        setCurrentWorkspace(ownWorkspace);
        navigate(`/dashboard/${ownWorkspace._id}`);
      }
    } else {
      navigate("/auth");
    }
  }, [currentWorkspace, user]);

  return null;
};

export default NoWorkspaceFound;
